import ServiceRequestError from "Services/ServiceRequestError";
import { injectable } from "inversify";
import ExceptionModel from "Models/ExceptionModel";
import ServiceRequest from "Services/ServiceRequest";
import HttpRequestOptions from "Services/Http/HttpRequestOptions";
import { HttpRequestBodyType, Url } from 'ts-common-utils';

@injectable()
export default class HttpService {

    public httpGet(url: Url, options?: Partial<HttpRequestOptions>): ServiceRequest {
        options = new HttpRequestOptions(options);
        let request = new XMLHttpRequest();
        request.open("GET", url.toString(), true);
        request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        request.onload = () => {
            this.handleResponse(request, options!.onSuccess, options!.onFailure);
        }
        request.timeout = options!.timeout!;
        request.send(Url.urlEncode(options!.bodyObject));
        return new ServiceRequest(request);
    }

    public httpPost(url: Url, options?: Partial<HttpRequestOptions>): ServiceRequest {
        options = new HttpRequestOptions(options);
        let request = new XMLHttpRequest();
        request.open("POST", url.toString(), true);
        switch (options.sendAs) {
            case HttpRequestBodyType.JSON:
                request.setRequestHeader("Content-Type", "application/json");
                break
            case HttpRequestBodyType.FormUrlEncoded:
                request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                break
        }
        request.onload = () => {
            this.handleResponse(request, options!.onSuccess, options!.onFailure);
        }
        request.timeout = options!.timeout!;
        switch (options.sendAs) {
            case HttpRequestBodyType.JSON:
                request.send(JSON.stringify(options!.bodyObject));
                break
            case HttpRequestBodyType.FormUrlEncoded:
                request.send(Url.urlEncode(options!.bodyObject));
                break
        }     
        
        return new ServiceRequest(request);
    }

    private handleResponse(request: XMLHttpRequest, onSuccess?: ((data: any) => void), onFailure?: ((error: ServiceRequestError) => void)) {
        if (request.status != 200 && request?.getResponseHeader('content-type')?.startsWith("application/json")) {
            if (onFailure != undefined) {
                let exception = new ExceptionModel(JSON.parse(request.responseText));
                let error: ServiceRequestError = new ServiceRequestError(exception.message!);
                error.statusCode = request.status;
                error.exceptionName = exception.exceptionName;
                error.fieldName = exception.fieldName;
                onFailure(error);
            }
        } else if (request.status != 200) {
            if (onFailure != undefined) {
                let error: ServiceRequestError = new ServiceRequestError(request.responseText);
                error.statusCode = request.status;
                onFailure(error);
            }
        } else {
            if (onSuccess != undefined) {
                if (!String.isNullOrEmpty(request.responseText) && request?.getResponseHeader('content-type')?.startsWith("application/json")) {
                    let json = JSON.parse(request.responseText);
                    onSuccess(json);
                } else {
                    onSuccess(request.responseText);
                }
            }
        }
    }
}